
import { HeroSection } from "@/components/promoters/HeroSection";
import { BenefitsSection } from "@/components/promoters/BenefitsSection";
import { CoreFeaturesSection } from "@/components/promoters/CoreFeaturesSection";
import { ComingSoonSection } from "@/components/promoters/ComingSoonSection";
import { TestimonialsSection } from "@/components/promoters/TestimonialsSection";
import { FinalCTASection } from "@/components/promoters/FinalCTASection";

const Promoters = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-gray-800">
      <HeroSection />
      <BenefitsSection />
      <CoreFeaturesSection />
      <ComingSoonSection />
      <TestimonialsSection />
      <FinalCTASection />
    </div>
  );
};

export default Promoters;
